import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TitleStrategy } from '@angular/router';

import { AuthInterceptor, ErrorInterceptor } from '@modules/core/interceptors';
import { initProvider } from '@modules/core/app-initializer/app.initializer';
import {
  DateCalendarService,
  GlobalService,
  LanguageFactory,
  LayoutService,
  LocalStorageService,
  SessionStorageService,
  ThemeService,
} from '@modules/core/services';
import { CustomPageTitleStrategy } from '@modules/core/utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiModule } from '@paymash/sdk/api';
import { ApiModule as localApiModule } from '@paymash/local-sdk/api';

@NgModule({
  imports: [CommonModule, HttpClientModule, localApiModule, ApiModule.forRoot()],
  providers: [
    initProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: LanguageFactory,
      deps: [TranslateService],
      multi: true,
    },
    { provide: TitleStrategy, useClass: CustomPageTitleStrategy },
    ThemeService,
    LayoutService,
    GlobalService,
    SessionStorageService,
    DateCalendarService,
    LocalStorageService,
  ],
})
export class CoreModule {}
